import { getCustomizations } from "../../customization/selectors";
import { createSelector } from "reselect";
import { getAllAccounts } from "./selectors";
import { formatInvestAccountsForDropdown } from "./utils";
import { AccountLOB, AccountStatus, } from "../types";
/**
 * Returns all invest accounts or an empty array.
 */
var getAllInvestAccounts = createSelector(getAllAccounts, function (accounts) {
    var _a;
    return (_a = accounts === null || accounts === void 0 ? void 0 : accounts.filter(function (account) {
        return [AccountLOB.INVEST, AccountLOB.WEALTH].includes(account.lob);
    })) !== null && _a !== void 0 ? _a : [];
});
var getOpenInvestAccounts = createSelector(getAllInvestAccounts, function (accounts) {
    return accounts.filter(function (_a) {
        var status = _a.status;
        return status !== AccountStatus.CLOSED;
    });
});
/**
 * Returns true/false whether any invest accounts have the `lastUpdated` property defined
 */
var getHasStaleAccounts = createSelector(getAllInvestAccounts, function (accounts) {
    return accounts.some(function (account) { return !!account.lastUpdated; });
});
var getInvestAccountsForDropdown = createSelector(getAllInvestAccounts, function (_, customizations) { return getCustomizations(customizations); }, function (investSummary, customizationDomain) {
    // istanbul ignore next
    if (investSummary === null)
        return [];
    return formatInvestAccountsForDropdown(investSummary, customizationDomain);
});
export default {
    getAll: getAllInvestAccounts,
    getAllForDropdown: getInvestAccountsForDropdown,
    getHasStaleAccounts: getHasStaleAccounts,
    getOpen: getOpenInvestAccounts,
};
//# sourceMappingURL=invest.js.map